/** @ignore */
export const APP_VERSION = '##APP_VERSION##'
/** @ignore */
export const APP_GLOBAL = '##APP_GLOBAL##'

/**
 * Global Variable Name of IBSheet
 * @ignore
 */
export const IBSHEET_GLOBAL = 'IBSheet'

/**
 * Unique Name for IBSheet
 * @ignore
 */
export const IBSHEET = 'ibsheet'

/**
 * Auto Generate Sheet ID Prefix
 * @ignore
 */
export const IBSHEET_PREFIX = 'sheet_'

/**
 * Auto Generate Sheet Element ID Prefix
 * @ignore
 */
export const IBSHEET_EL_PREFIX = 'sheetouter_'

/** @ignore */
export const IBCHART_GLOBAL_OBJECT = 'IBCharts'

/** @ignore */
export const IBCHART_GLOBAL = 'IBChart'

/** @ignore */
export const IBCHART = 'ibchart'

/** @ignore */
export const IBCHART_PREFIX = 'chart_'

/** @ignore */
export const IBCHART_EL_PREFIX = 'chartouter_'

/** @ignore */
export const IBMAP_GLOBAL = 'IBMapCharts'

/** @ignore */
export const IBMAP = 'ibmap'

/** @ignore */
export const IBMAP_PREFIX = 'map_'

/** @ignore */
export const IBMAP_EL_PREFIX = 'mapouter_'
